import React from "react";

import {
  Segment,
  Icon,
  Header,
  Card,
  Message,
  Container
} from "semantic-ui-react";

import PlaidLinkConnector from "../../../components/PlaidLinkConnector";

import { connect } from "react-redux";

const BankAccount = props => {
  const account = props.account;
  return (
    <Card style={{ maxWidth: "250px" }}>
      <Card.Content>
        <Card.Header>{account.name}</Card.Header>
        <Card.Meta>****{account.mask}</Card.Meta>
      </Card.Content>
      <Card.Content extra>
        <Card.Meta style={{ textTransform: "capitalize" }}>
          {account.kind === "depository" ? account.subkind : account.kind}{" "}
          Account
        </Card.Meta>
      </Card.Content>
    </Card>
  );
};

const status = bank => {
  if (bank.status === "ok") {
    return {
      color: "green",
      type: "positive",
      icon: "check",
      message: "Successfully connected to " + bank.bank_name + "."
    };
  } else if (bank.status === "initial_wait") {
    return {
      color: "grey",
      type: "info",
      icon: "check",
      message: "Successfully connected, waiting for initial data."
    };
  } else if (bank.status === "error") {
    return {
      color: "red",
      type: "negative",
      icon: "times",
      message:
        "We're having trouble connecting to " +
        bank.bank_name +
        ". " +
        bank.error_message
    };
  }
};

const Bank = props => {
  const bank = props.bank;
  const { color, icon, message, type } = status(bank);
  return (
    <Segment.Group>
      <Segment color={color}>
        <Header as="h3" dividing>
          <Icon name="university" />
          <Header.Content>
            {bank.bank_name}
            <Header.Subheader>
              {bank.accounts.length} connected{" "}
              {bank.accounts.length !== 1 ? "accounts" : "account"}
            </Header.Subheader>
          </Header.Content>
        </Header>
        <Card.Group>
          {bank.accounts.map(account => (
            <BankAccount account={account} key={account.uuid} />
          ))}
        </Card.Group>
      </Segment>
      <Message attached="bottom" {...{ [type]: true }}>
        <Icon name={icon} />
        {message}
      </Message>
    </Segment.Group>
  );
};

const BankSettingsView = props => {
  return (
    <div>
      <Message icon={true}>
        <Icon name="lock" />
        <Message.Content>
          <Message.Header>Your bank information is secure.</Message.Header>
          <p>
            Spout uses{" "}
            <a
              href="https://plaid.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Plaid
            </a>{" "}
            to securely interact with your bank account. Plaid handles all
            interactions with your bank - Spout never sees your username or
            password, and can only access your transaction data through Plaid's
            servers.
          </p>
        </Message.Content>
      </Message>
      <Header dividing as="h4">
        Your bank information
      </Header>
      <Container text>
        {props.banks.map(bank => <Bank bank={bank} key={bank.uuid} />)}
        <Segment color="blue">
          <Header as="h3" dividing>
            <Icon name="lock" />
            <Header.Content>
              { props.banks.length === 0 && "Add your first bank account to Spout."}
              { props.banks.length > 0 && "Add another bank account to Spout."}
              <Header.Subheader>
                Connecting your bank is fast and secure.
              </Header.Subheader>
            </Header.Content>
          </Header>
          <div style={{ textAlign: "center", marginBottom: "2em" }}>
            { props.banks.length === 0 && <PlaidLinkConnector message="Connect with Plaid" />}
            { props.banks.length > 0 && <PlaidLinkConnector />}
          </div>
          <p>
            Use the button above to open{" "}
            <a
              href="https://plaid.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Plaid
            </a>{" "}
            and connect your bank to Spout.
          </p>
        </Segment>
      </Container>
    </div>
  );
};

const mapStateToProps = state => ({
  banks: state.organization.bank_credentials
});

export default connect(mapStateToProps)(BankSettingsView);



// WEBPACK FOOTER //
// ./frontend/src/views/pages/settings/BankSettingsView.js